import * as React from 'react';
import { injectIntl } from 'react-intl';
import { connect, MapStateToProps } from 'react-redux';
import { RouterProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { IntlProps } from '../../';
import { RootState, selectConfigsLoading } from '../../modules';

interface ReduxProps {
    configsLoading: boolean;
}

interface LocationProps extends RouterProps {
    location: {
        pathname: string;
    };
}

const noFooterRoutes = ['/confirm', '/404', '/500', '/', '/signin', '/signup', '/rank', '/profile', '/company'];

type FooterProps = LocationProps & ReduxProps & IntlProps;

class FooterComponent extends React.Component<FooterProps> {
    public render() {
        const { location, configsLoading } = this.props;
        const shouldRenderFooter = !noFooterRoutes.some((r) => location.pathname === r);
        const isTrading = location.pathname.includes('/trading');
        if (!shouldRenderFooter || configsLoading) {
            return <React.Fragment />;
        }

        return (
            <React.Fragment>
                <footer
                    className="pg-footer"
                    style={{
                        backgroundColor: isTrading ? 'var( --main-background-color)' : 'var(--main-background-color)',
                    }}>
                    <span style={{ color: 'var(--main-text-color)' }}>
                        Price x 1,000 VND. Volume x 1. Value x 1,000,000 VND.
                    </span>
                    {/* <a href="https://www.openware.com">huyhk.com</a> */}
                </footer>
            </React.Fragment>
        );
    }

    public translate = (key: string) => this.props.intl.formatMessage({ id: key });
}

const mapStateToProps: MapStateToProps<ReduxProps, {}, RootState> = (state) => ({
    configsLoading: selectConfigsLoading(state),
});

export const Footer = compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(FooterComponent) as React.ComponentClass;
